(function initializePlugPostHogConsent(windowObject, documentObject) {
  const attributionKeys = ["plug_journey_id", "plug_journey_expires_at"];
  let active = false;
  let operation = Promise.resolve();
  let analyticsId = null;
  const ANALYTICS_ID = /^pc_[A-Za-z0-9_-]{22}$/;

  function clearAttributionStorage() {
    try {
      attributionKeys.forEach((key) => windowObject.localStorage.removeItem(key));
      windowObject.sessionStorage.removeItem("plug_attribution_touch_fingerprint");
    } catch (_error) {
      // Browsers that deny storage must still be able to shop and choose consent.
    }
  }

  function signedIn() {
    return Boolean(windowObject.__st?.cid || windowObject.ShopifyAnalytics?.meta?.page?.customerId);
  }

  // Ties this visitor's events to a signed-in customer by the keyed hash My Devices returns. Only
  // with analytics consent; signing out drops it again.
  function syncIdentity() {
    const posthog = windowObject.posthog;
    if (!active || typeof posthog?.identify !== "function") return;
    const current = posthog.get_distinct_id?.() || "";
    if (analyticsId) {
      if (current !== analyticsId) posthog.identify(analyticsId);
    } else if (ANALYTICS_ID.test(current) && !signedIn()) {
      posthog.reset(true);
    }
  }

  function syncConsent() {
    let allowed = false;
    try {
      allowed = windowObject.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch (_error) {
      allowed = false;
    }
    const posthog = windowObject.posthog;
    if (!posthog || typeof posthog.get_distinct_id !== "function") return;
    if (!allowed) {
      posthog.opt_out_capturing();
      if (active) posthog.reset(true);
      posthog.set_config({ persistence: "memory" });
      active = false;
      return;
    }
    if (active) return;
    posthog.set_config({ persistence: "localStorage+cookie" });
    if (/^pj1\./.test(posthog.get_distinct_id?.() || "")) posthog.reset(true);
    ["plug_journey_id", "plug_consent_coverage", "plug_attribution_release"].forEach((key) =>
      posthog.unregister(key)
    );
    // Skip the $opt_in event: this runs on every consented page load, not once per visitor.
    posthog.opt_in_capturing({ captureEventName: false });
    windowObject.PlugPostHogPerformance?.registerForConsentedSession?.();
    posthog.capture("$pageview");
    active = true;
    syncIdentity();
  }

  function refreshConsent() {
    operation = operation
      .then(syncConsent)
      .catch(() => windowObject.posthog?.opt_out_capturing?.());
  }

  // The attribution program ended on 2026-09-14. Its cart attributes outlived every cart long
  // ago, so only the cheap browser-storage cleanup stays (no /cart.js read on every page).
  clearAttributionStorage();
  documentObject.addEventListener("visitorConsentCollected", refreshConsent);
  documentObject.addEventListener("plug:analytics-id", (event) => {
    const id = event?.detail?.id;
    if (typeof id !== "string" || !ANALYTICS_ID.test(id)) return;
    analyticsId = id;
    operation = operation.then(syncIdentity).catch(() => {});
  });
  if (windowObject.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {
    refreshConsent();
  } else if (typeof windowObject.Shopify?.loadFeatures === "function") {
    windowObject.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      refreshConsent
    );
  }
  windowObject.PlugPostHogConsent = Object.freeze({
    refreshConsent,
    whenIdle: () => operation,
  });
})(window, document);
